const content = `
<p class="ql-align-center">
  <strong>
    《只二AI鉴别服务须知》
  </strong>
</p>
<p class="ql-align-justify">
  &nbsp;
</p>
<p class="ql-align-justify">
  请您在使用AI鉴别前谨慎完整地阅读只二AI鉴别服务须知（以下简称“规则”），并确保您在完全知情并接受本规则的情况下使用AI鉴别服务。如果您对本规则不同意或不理解，您应停止使用AI鉴别服务。如您继续使用AI鉴别服务，则视为您认可并同意本规则全部内容。
</p>
<p class="ql-align-justify">
  &nbsp;
</p>
<p class="ql-align-justify">
  一、只二的AI鉴别服务是从您上传的图片中提取特征点，最终基于图片中的特征进行判断的服务。
</p>
<p class="ql-align-justify">
  &nbsp;
</p>
<p class="ql-align-justify">
  二、在上传鉴别图片前，您需仔细阅读并按照《新手必看》要求上传图片。
</p>
<p class="ql-align-justify">
  &nbsp;
</p>
<p class="ql-align-justify">
  三、您应知悉：远程鉴别不可避免地存在一定的局限性，例如照片拍摄角度、光线、清晰度等诸多影响因素，从而出现多次鉴别结果不完全一致的情况，有别于线下对实物触摸查验的感官分辨，因此不可代替实物鉴别。
</p>
<p class="ql-align-justify">
  &nbsp;
</p>
<p class="ql-align-justify">
  四、平台在现有技术的基础上尽最大努力提供相应服务，在您按要求拍摄照片的情况下，AI鉴别结果可保证您95%以上的准确性，但由于照片拍摄存在局限性，因此最终鉴别结果以实物鉴别为准。
</p>
<p class="ql-align-justify">
  &nbsp;
</p>
<p class="ql-align-justify">
  五、在只二有操作提示的情况下由于您操作不当（包括但不限于：未按示例要求拍摄、鉴别品牌选择错误、恶意拼凑图片）导致的鉴别结果偏差，您应自行承担后果。
</p>
<p class="ql-align-justify">
  &nbsp;
</p>
<p class="ql-align-justify">
  六、本规则由只二平台制定并公示，只二有权对本规则进行调整及修改，并向用户进行公示后执行。只二对本平台的AI鉴别技术有最终解释权。如果您对本规则存在疑问，可联系客服进行咨询。
</p>
<p>
  <br>
</p>
`
export default {
  content,
  title: '鉴别须知'
}
